module.exports = __webpack_public_path__ + "assets/ic-coinidol.5a7004ba.svg";